import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PaymentProviderConfiguration} from '../../../models/payments/paymentProviderConfiguration.model';
import {Store} from '@ngxs/store';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {Address} from '../../../models/accounts/address.model';
import {PaymentsService} from '../../../services/payments.service';
import {PaymentIntent} from '@stripe/stripe-js';
import {AnimationOptions} from 'ngx-lottie';

@Component({
  standalone: false,
  selector: 'app-payment-gateway',
  templateUrl: './payment-gateway.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./payment-gateway.component.scss']
})
export class PaymentGatewayComponent implements OnInit {
  @Input()
  public jobId: string;

  @Input()
  public billingAddress: Address;

  @Input()
  public organizationHandle?: string;
  @Input()
  public organizationId?: string;

  @Input()
  public paymentProviderConfig: PaymentProviderConfiguration;
  public showSuccessMessage: boolean;
  public showFailureMessage: boolean;
  public errorMessage: string;
  public loadingIndicator: boolean;
  public componentLoadingIndicator: boolean;
  public paymentGatewayResetObservable: Subject<void>;

  public loadingOptions: AnimationOptions = {
    path: 'assets/lottie/payment_loading.json',
  };
  public stripePaymentIntent: PaymentIntent;

  constructor(private store: Store, private router: Router, private paymentService: PaymentsService) {
    this.showSuccessMessage = false;
    this.showFailureMessage = false;
    this.loadingIndicator = false;
    this.paymentGatewayResetObservable = new Subject<void>();
  }

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.loadingIndicator = true;
    this.paymentService.initiatePayment({
      id: this.jobId,
      billingAddress: this.billingAddress,
      request: {}
    }, {organization: this.organizationHandle}).subscribe((res) => {
      // If payment is successful
      if (res.currentStatus === 'PAYMENT_SUCCESS') {
        this.showSuccessMessage = true;
        this.loadingIndicator = false;
        return;
      }
      // Do stripe things
      if (this.paymentProviderConfig.provider === 'STRIPE') {
        this.stripePaymentIntent = JSON.parse(res.paymentProviderResponse);
      }
      this.loadingIndicator = false;
    });
  }


  refreshPayment(): void {
    this.showFailureMessage = false;
    this.showSuccessMessage = false;
    this.init();
  }

  stripePaymentEvent(event: { paymentIntent?: PaymentIntent, savePaymentMethod: boolean, loading: boolean }): void {
    this.componentLoadingIndicator = event.loading;
    if (event.paymentIntent) {
      this.loadingIndicator = true;
      this.paymentService.completePayment({
        id: this.jobId,
        sendInvoiceEmail: false,
        sendNewOrderEmail: false,
        savePaymentMethod: event.savePaymentMethod,
        request: {}
      }, {organization: this.organizationHandle}).subscribe((res) => {
        this.stripePaymentIntent = JSON.parse(res.paymentProviderResponse);
        if (this.stripePaymentIntent.status === 'succeeded') {
          this.showSuccessMessage = true;
        } else {
          this.errorMessage = this.stripePaymentIntent.last_payment_error.message;
          this.showFailureMessage = true;
        }
        this.loadingIndicator = false;
      });
    }
  }
}
